module.exports = __webpack_public_path__ + "media/images/icon_comment-07b676413eb227e3e8ae6b6cec66bc1a.svg";